<template>
  <sfs-base-table
    :key="tableKey"
    :data-provider="$quoteTemplatesAPI.getTemplates"
    provider-key="quoteTemplates"
    :columns="columns"
    :filters="filters"
    :current-page="currentPage"
    :per-page="perPage"
    :show-per-page="showPerPage"
  >
    <template #cell(name)="data">
      <div>{{ data.item.name }}</div>
      <div
        v-if="data.item.client"
        class="font-size-sm text-secondary"
      >
        <b-link :to="{ name: 'client', params: { id: data.item.client.id } }">
          {{ data.item.client.name }}
        </b-link>
      </div>
    </template>
    <template #cell(description)="data">
      <text-with-popover
        v-if="data.item.description && data.item.description != data.item.service?.name"
        :popover-id="`quote-template-${data.item.id}-description`"
        :text="data.item.description"
      />
      <b-link
        v-if="data.item.service"
        class="font-size-sm text-prewrap"
        :to="{ name: 'service', params: { id: data.item.service.id } }"
      >
        {{ data.item.service.name }}
      </b-link>
    </template>
    <template #cell(cost)="data">
      <money-format
        v-if="data.item.cost"
        :value="data.item.cost.amount"
        :currency-code="data.item.cost.currency"
        subunits-value
      />
    </template>
    <template #cell(price)="data">
      <money-format
        v-if="data.item.price"
        :value="data.item.price.amount"
        :currency-code="data.item.price.currency"
        subunits-value
      />
    </template>
    <template #cell(active)="data">
      <b-badge
        v-if="!data.item.deleted_at"
        variant="success"
      >
        Active
      </b-badge>
      <b-badge
        v-else
        variant="danger"
      >
        Inactive
      </b-badge>
    </template>
    <template #cell(actions)="data">
      <div class="text-nowrap">
        <b-button
          v-if="$can('create', 'Quote')"
          v-b-tooltip.hover
          size="sm"
          variant="link"
          class="mr-1"
          title="Create quote from template"
          :to="{ name: 'new-quote', query: { quote_template_id: data.item.id } }"
        >
          <i class="fa fa-fw fa-file-invoice" />
        </b-button>
        <b-button
          v-if="$can('update', 'QuoteTemplate')"
          size="sm"
          variant="link"
          class="mr-1"
          :to="{ name: 'quote-template', params: { id: data.item.id } }"
        >
          <i class="fa fa-fw fa-pencil-alt" />
        </b-button>
        <b-button
          v-if="$can('destroy', 'QuoteTemplate')"
          v-b-tooltip.hover
          size="sm"
          variant="link"
          :title="toggleActiveTooltipText(!data.item.deleted_at)"
          @click="toggleActive(data.item.id, !data.item.deleted_at)"
        >
          <i
            v-if="!data.item.deleted_at"
            class="fa fa-fw fa-times"
          />
          <i
            v-else
            class="fa fa-undo"
          />
        </b-button>
      </div>
    </template>
  </sfs-base-table>
</template>

<script>
import tablePropsMixin from '@/mixins/tablePropsMixin';
import { QUOTE_TEMPLATE_TABLE_DEFAULT_COLUMNS } from '@/constants/quoteTemplates';
import { DateTime } from 'luxon';
import TextWithPopover from '@/components/shared/TextWithPopover.vue';

export default {
  name: 'QuoteTemplatesTable',
  mixins: [tablePropsMixin],
  components: {
    TextWithPopover,
  },
  props: {
    columns: {
      type: Array,
      default: () => QUOTE_TEMPLATE_TABLE_DEFAULT_COLUMNS,
    },
  },
  methods: {
    toggleActiveTooltipText(deletedAt) {
      return deletedAt ? 'Deactivate' : 'Reactivate';
    },
    toggleActiveConfirmText(deletedAt) {
      return deletedAt
        ? 'Are you sure you want to deactivate the quote template?'
        : 'Are you sure you want to reactivate the quote template?';
    },
    toggleActive(id, deletedAt) {
      this.$swal({
        text: this.toggleActiveConfirmText(deletedAt),
        preConfirm: () => this.$quoteTemplatesAPI.update(id, { deleted_at: (deletedAt ? DateTime.now().toISODate() : null) }),
      }).then((result) => {
        if (result.value) {
          this.refreshTable();
        }
        result.timer;
      });
    },
  },
};
</script>
